import { Modal }                    from '../../common/modal';
import KindleTroubleModalTemplate   from '../templates/KindleTroubleModal.html';
import KindleTroubleResponseModal   from './KindleTroubleResponseModal';
import RadioButton                  from '../../common/RadioButton';

import MediaInterface               from '../../media/MediaInterface';

export default class KindleTroubleModal extends Modal {

    constructor({titleId, alternativeFormat}) {
        const modalContents = {
            classes: ['KindleTroubleModal'],
            title: window.html('kindleFulfillment.reportKindleTrouble'),
            content: KindleTroubleModalTemplate()
        };
        super(modalContents);

        this._buildRadioGroup();

        this.$el.find('.submit-button').on('click', () => {
            const selectedOption = this.$el.find('.radio-container input[type="radio"]:checked').val();
            this._logKindleError(titleId, selectedOption);
            const responseModal = new KindleTroubleResponseModal(this._responseModalOption(selectedOption), alternativeFormat);
            this.close();
        });
    }

    _buildRadioGroup() {
        let rid = Math.random().toString(36).substring(7);
        const badLink = new RadioButton({
            value: 'badLink',
            checked: true,
            el: '.badLink-radio',
            className: 'troubleRadio',
            name: 'troubleRadio',
            label: window.html('kindleFulfillment.kindleTroubleModal.badLink'),
            rid
        }).render();

        const wrongTitle = new RadioButton({
            value: 'wrongTitle',
            el: '.wrongTitle-radio',
            className: 'troubleRadio',
            name: 'troubleRadio',
            label: window.html('kindleFulfillment.kindleTroubleModal.wrongTitle'),
            rid
        }).render();

        const incompatibleDevice = new RadioButton({
            value: 'incompatibleDevice',
            el: '.incompatibleDevice-radio',
            className: 'troubleRadio',
            name: 'troubleRadio',
            label: window.html('kindleFulfillment.kindleTroubleModal.incompatibleDevice'),
            rid
        }).render();

        const other = new RadioButton({
            value: 'other',
            el: '.other-radio',
            className: 'troubleRadio',
            name: 'troubleRadio',
            label: window.html('titleDetails.other'),
            rid
        }).render();
    }

    _logKindleError(titleId, selectedOption) {
        const mediaInterface = new MediaInterface();

        mediaInterface.search({titleId}).then((title) => {
            window.Logger.log('warn', this._errorMessage(selectedOption), {
                message: 'KindleTroubleReport',
                id: title ? title.id : '',
                reserveId: title ? title.reserveId : '',
                isbn: this._pluckIdentifier(title, 'ISBN') || '',
                asin: this._pluckIdentifier(title, 'ASIN') || '',
                title: title ? title.title : '',
                creator: title ? title.firstCreatorName : ''
            });
        });
    }

    _pluckIdentifier(title, identifierType = 'ISBN') {
        const formats = title && title.formats;
        const identifiers = formats && formats.length > 0 ? [].concat(...formats.map((format) => format.identifiers)) : undefined;
        const ofType = identifiers && identifiers.length > 0
            ? identifiers.filter((identifier) => identifier.type === identifierType).map((identifier) => identifier.value)
            : undefined;
        return ofType && ofType.length > 0 ? ofType[0] : undefined;
    }

    _errorMessage(selectedOption) {
        switch (selectedOption) {
            case 'badLink':
                return 'Link to title broken';
            case 'wrongTitle':
                return 'Wrong title delivered to device';
            case 'incompatibleDevice':
                return 'Can\'t send title to device';
            default:
                return 'Other/unspecified';
        }
    }

    _responseModalOption(selectedOption) {
        switch (selectedOption) {
            case 'badLink':
                return 'broken';
            case 'wrongTitle':
                return 'broken';
            case 'incompatibleDevice':
                return 'device';
            default:
                return 'other';
        }
    }
}
